import { toPlatePlugin } from '@udecode/plate-common/react';

import { BaseTextIndentPlugin } from '../lib';

export const TextIndentPlugin = toPlatePlugin(BaseTextIndentPlugin);
